import React from "react";

function EmptyCard({ text }) {
  return (
    <div className="flex h-24 items-center justify-center rounded-xl border border-dashed border-[#d8e7ed] bg-[#f8fbfc] px-4 text-center dark:border-dark-border dark:bg-dark-surface">
      <p className="max-w-xs text-[10px] leading-5 text-[#8194a0] dark:text-dark-text-muted">{text}</p>
    </div>
  );
}

export default EmptyCard;
